export default __webpack_public_path__ + "static/media/my-light.012c5110.svg";